function Tag({ tagName }) {
  return (
    <div className="tag">
      <span className="tag-name">{tagName}</span>
    </div>
  );
}

export default Tag